if (!customElements.get('quick-add-modal')) {
    customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
        constructor() {
            super();
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            this.isLoading = false;
        }

        hide(preventFocus = false) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
            
            // Clear content immediately for faster perception
            requestAnimationFrame(() => {
                this.modalContent.innerHTML = '';
            });

            // Destroy swipers more efficiently
            this.destroySwipers();

            if (preventFocus) this.openedBy = null;
            super.hide();
        }

        destroySwipers() {
            try {
                $('.js-media-list, .js-media-sublist').each(function () {
                    if (this.swiper && typeof this.swiper.destroy === 'function') {
                        this.swiper.destroy(true, true);
                    }
                });
            } catch (error) {
                console.warn('Swiper destruction error:', error);
            }
        }

        async show(opener) {
            // Prevent multiple simultaneous loads
            if (this.isLoading) return;
            this.isLoading = true;

            this.setLoadingState(opener, true);

            try {
                const response = await fetch(opener.getAttribute('data-product-url'));
                if (!response.ok) throw new Error('Network response was not ok');
                
                const responseText = await response.text();
                await this.processResponse(responseText, opener);
            } catch (error) {
                console.error('Quick add modal error:', error);
                this.handleError(opener);
            } finally {
                this.setLoadingState(opener, false);
                this.isLoading = false;
            }
        }

        setLoadingState(opener, isLoading) {
            if (isLoading) {
                opener.setAttribute('aria-disabled', true);
                opener.classList.add('loading');
                const spinner = opener.querySelector('.loading-overlay__spinner');
                if (spinner) spinner.classList.remove('hidden');
            } else {
                opener.removeAttribute('aria-disabled');
                opener.classList.remove('loading');
                const spinner = opener.querySelector('.loading-overlay__spinner');
                if (spinner) spinner.classList.add('hidden');
            }
        }

        async processResponse(responseText, opener) {
            // Use DocumentFragment for better performance
            const fragment = document.createDocumentFragment();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = responseText;
            
            this.productElement = tempDiv.querySelector('section[id^="MainProduct-"]');
            if (!this.productElement) {
                throw new Error('Product element not found');
            }

            // Process DOM modifications in batches
            await this.batchDOMOperations(opener);
        }

        async batchDOMOperations(opener) {
            // Batch 1: ID prevention and DOM cleanup
            await this.scheduleMicrotask(() => {
                this.preventDuplicatedIDs();
                this.removeDOMElements();
            });

            // Batch 2: Set content with image loading optimization
            await this.scheduleMicrotask(() => {
                this.setInnerHTMLOptimized(this.modalContent, this.productElement.innerHTML, opener);
            });

            // Batch 3: Initialize components
            await this.scheduleMicrotask(() => {
                this.initializeComponents();
            });

            // Batch 4: Final setup
            await this.scheduleMicrotask(() => {
                this.finalizeSetup(opener);
            });
        }

        scheduleMicrotask(callback) {
            return new Promise(resolve => {
                requestAnimationFrame(() => {
                    callback();
                    resolve();
                });
            });
        }

        setInnerHTMLOptimized(element, html, opener) {
            // Create container for better performance
            const container = document.createElement('div');
            container.innerHTML = html;

            // Optimize images before inserting
            this.optimizeImages(container);

            // Insert content
            element.appendChild(container);

            // Reinject scripts asynchronously
            setTimeout(() => this.reinjectScripts(element), 0);

            // Add read more button
            this.addReadMoreButton(element, opener);
        }

        optimizeImages(container) {
            const images = container.querySelectorAll('img');
            images.forEach(img => {
                // Add loading="lazy" if not present
                if (!img.hasAttribute('loading')) {
                    img.setAttribute('loading', 'lazy');
                }
                
                // Add decoding="async" for better performance
                img.setAttribute('decoding', 'async');
                
                // Preload critical images (first few)
                const isFirstImage = Array.from(images).indexOf(img) < 3;
                if (isFirstImage) {
                    img.setAttribute('loading', 'eager');
                    // Create preload link for critical images
                    this.preloadImage(img.src);
                }
            });
        }

        preloadImage(src) {
            if (src && !document.querySelector(`link[href="${src}"]`)) {
                const link = document.createElement('link');
                link.rel = 'preload';
                link.as = 'image';
                link.href = src;
                document.head.appendChild(link);
            }
        }

        reinjectScripts(element) {
            element.querySelectorAll('script').forEach(oldScriptTag => {
                const newScriptTag = document.createElement('script');
                Array.from(oldScriptTag.attributes).forEach(attribute => {
                    newScriptTag.setAttribute(attribute.name, attribute.value);
                });
                newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
        }

        addReadMoreButton(element, opener) {
            const infoContainer = element.querySelector('.product__info-container');
            if (infoContainer) {
                const moreBtn = document.createElement('a');
                moreBtn.textContent = `${theme.quickviewMore}`;
                moreBtn.setAttribute('href', opener.getAttribute('data-product-url'));
                moreBtn.setAttribute('class', 'product__full-details card__link button cart-button button--primary card__link-button-fixed card-focused custom_product');
                infoContainer.appendChild(moreBtn);
            }
        }

        initializeComponents() {
            // Initialize Shopify components
            if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
                window.ProductModel.loadShopifyXR();
            }

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
        }

        finalizeSetup(opener) {
            // Initialize sliders with delay to ensure DOM is ready
            setTimeout(() => {
                try {
                    subSliderInit();
                    sliderInit();
                } catch (error) {
                    console.warn('Slider initialization error:', error);
                }
            }, 100);

            // Setup show more functionality
            $('.js-show-more').off('click').on('click', function (e) {
                e.preventDefault();
                $(this).siblings('input').removeClass('hidden');
                $(this).siblings('label').removeClass('hidden');
                $(this).remove();
            });

            // Show modal after everything is ready
            super.show(opener);
        }

        handleError(opener) {
            console.error('Failed to load product data');
            // You could show an error message to the user here
        }

        // Cache frequently accessed elements
        removeDOMElements() {
            const selectors = [
                'related-slider',
                '.promo-banner',
                '[data-block-handle="reviews"]',
                '.about',
                '.product__text',
                '.share-buttons',
                '.rating',
                '#shopify-product-reviews',
                '.product-tags',
                '.product__description',
                '.advantage-wrapper',
                '.note',
                'pickup-availability',
                'product-modal',
                'floated-form',
                'product-variant-values',
                '.customer'
            ];

            selectors.forEach(selector => {
                const elements = this.productElement.querySelectorAll(selector);
                elements.forEach(el => el.remove());
            });
        }

        preventDuplicatedIDs() {
            const sectionId = this.productElement.dataset.section;
            this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
            this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
                variantSelect.dataset.originalSection = sectionId;
            });
        }

        preventVariantURLSwitching() {
            const variantElement = this.modalContent.querySelector('variant-radios,variant-selects');
            if (variantElement) {
                variantElement.setAttribute('data-update-url', 'false');
            }
        }

        removeGalleryListSemantic() {
            const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
            if (!galleryList) return;

            galleryList.setAttribute('role', 'presentation');
            galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
        }

        updateImageSizes() {
            const product = this.modalContent.querySelector('.product');
            if (!product || !product.classList.contains('product--columns')) return;

            const mediaImages = product.querySelectorAll('.product__media img');
            if (!mediaImages.length) return;

            let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

            if (product.classList.contains('product--medium')) {
                mediaImageSizes = mediaImageSizes.replace('715px', '605px');
            } else if (product.classList.contains('product--small')) {
                mediaImageSizes = mediaImageSizes.replace('715px', '495px');
            }

            mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
        }
    });
}